export default {
    data: [],
    pagination: {
        page: 1,
        per_page: 25
    },
    sort: ["-created_at"],
    default_sort: ["-created_at"]
};
